import React from "react";
import "./App.css"; // Import the CSS file for styling

function CriminalLaw(){

    return <div>

<img src="/supreme-court-of-india.jpg" alt="Header" />
<h2>Criminal Law</h2>



    </div>;


}




export default CriminalLaw;